module.exports = __webpack_public_path__ + "static/pic05-db0fc8effc5dd1f12560300ae650f294.jpg";